import React, { Component } from 'react'
import PropTypes from 'prop-types';

export class Search extends Component {

    state = {
        text : ''
    }

    static propTypes = {
        searchUrl: PropTypes.func.isRequired,
        setAlert: PropTypes.func.isRequired
    }


    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmit=(e) => {
        e.preventDefault();
        //alert for submit blank form
        if(this.state.text === ''){
            this.props.setAlert('Please enter a valid URL', 'light');
        } else {
            this.props.searchUrl(this.state.text);
            this.setState({ text: '' });
        }

    }

    render() {
        return (
            <div>
                <form onSubmit={this.onSubmit} className="form">
                    <input type="text" name="text" placeholder="Search URL..." value={this.state.text} onChange={this.onChange}/>
                    <input type="submit" value="Search" className="btn btn-dark btn-block" />
                </form>
                {this.props.showClear && <button className="btn btn-light btn-block" onClick={this.props.clearUsers}>Clear</button>}
                
            </div>
        )
    }
}

export default Search


// WEBPACK FOOTER //
// ./src/components/layout/Search.js